import { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from './components/global/Header.jsx';
import Footer from './components/global/Footer.jsx';
import PostList from './components/pages/PostList.jsx';
import About from './components/pages/About.jsx';
import Error from './components/pages/Error.jsx';
import NotFound from './components/pages/NotFound.jsx';

function App() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios(`${import.meta.env.VITE_API_URL}/${import.meta.env.VITE_STAGE}/posts`)
      .then(resp => {
        const postsData = resp.data.data.Items;
        setPosts(postsData);
        setLoading(false);
      })
      .catch(err => {
        console.log('problem!');
        console.error(err);
        setPosts([]);
        setLoading(false);
        navigate('/error');
      });
  }, [navigate]);

  // Dynamically import post components
  const postRoutes = posts.map(post => {
    const PostComponent = () => {
      const [Component, setComponent] = useState(null);

      useEffect(() => {
        import(`./components/posts/${post.url}/${post.url}.jsx`)
          .then(module => setComponent(() => module.default))
          .catch(err => {
            console.error(`Failed to load post component: ${post.url}`, err);
            navigate('/not-found');
          });
      }, []);

      if (!Component) return null;
      return <Component post={post} />;
    };

    return (
      <Route
        key={post.url}
        path={`/${post.url}`}
        element={<PostComponent />}
      />
    );
  });

  if (loading) {
    return null;
  }

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<PostList posts={posts} />} />
        <Route path="/about" element={<About />} />
        <Route path="/error" element={<Error />} />
        {postRoutes}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
